import { useState } from 'react'

import { customPost } from '../utils/customFetch.ts'

import { makeUrlSalenoteApprove } from './connectionData.tsx'

const useSalenoteApprove = () => {
  const [errorSalenoteApprove, setErrorSalenoteApprove] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const salenoteApprove = async (_id: string, by: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlSalenoteApprove()
      const res = await customPost<{ message: string }>(apiUrl, { _id, by })
      setErrorSalenoteApprove(null)

      return res
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorSalenoteApprove(err)
      } else {
        setErrorSalenoteApprove(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorSalenoteApprove, loading, salenoteApprove }
}
export default useSalenoteApprove
